// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class EventDescriptionItem {
    constructor(header = undefined, value = undefined) {
        this.Header = header || '';
        this.Value = value || '';
    }
}
